// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"NavModale_Overlay__1PiQm","NavModale":"NavModale_NavModale__1KE1Z","navLink":"NavModale_navLink__2gjff","activeNav":"NavModale_activeNav__2YIk8"};